/** 获取应用base的短表示，如"/compose" */
export const getApplicationShortBase = () => {
  return document.baseURI.slice(location.origin.length, document.baseURI.length)
}
